import { render } from "./PhoneModal.vue?vue&type=template&id=ea9e7de8&scoped=true"
import script from "./PhoneModal.vue?vue&type=script&lang=js"
export * from "./PhoneModal.vue?vue&type=script&lang=js"

import "./PhoneModal.vue?vue&type=style&index=0&id=ea9e7de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9e7de8"]])

export default __exports__